export default __webpack_public_path__ + "static/media/330_store04-fr-web.f4e3b300.png";